import { ViewportScroller } from '@angular/common';
import { Component, input, inject, computed, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Season } from '../../../services/api.service';
import { BookingService } from '../../../services/booking.service';
import { DOMHandlerService } from '../../../services/domhandler.service';
import { LanguageService } from '../../../services/language.service';
import { SharedNgxskeletonloaderModule } from '../../../services/ngxskeletonloader.module';
import { ButtonComponent } from '../../common/button/button.component';

@Component({
    selector: 'app-price-view',
    imports: [
        ButtonComponent,
        RouterLink,
        SharedNgxskeletonloaderModule,
        TranslatePipe,
    ],
    host: { class: 'container block mx-auto' },
    styleUrl:
        '../../common/text-field-markdown/text-field-markdown.component.css',
    templateUrl: './price-view.component.html',
})
export class PriceViewComponent {
    data = input.required<PriceView>();
    bookingService = inject(BookingService);
    languageService = inject(LanguageService);
    config = computed(() => this.bookingService.config.value());
    domhandler = inject(DOMHandlerService);
    selectedSeason = signal<Season | undefined>(undefined);
    array = computed(() =>
        Array.from(
            {
                length:
                    this.bookingService.config.value()?.data.maximumPeople || 9,
            },
            (_, i) => i + 1,
        ),
    );
    viewportScroller = inject(ViewportScroller);

    getCorrectSeasonName(season: Season | undefined) {
        if (!season) {
            return '';
        }
        if (this.languageService.getLanguageCode === 'en') {
            return season.seasonNameEnglish;
        }
        return season.seasonName;
    }

    scrollTo(id: string) {
        this.viewportScroller.scrollToAnchor(id);
    }
}

type PriceView = {
    priceViewTitle: string;
};
